<template>
	<span>
		<a v-if="teamKey" class="has-text-link effect" @click.prevent.stop="navigateToTeamPage()">{{ teamName }}</a>
		<span v-else>{{ teamName }}</span>
	</span>
</template>

<script>
export default {
	props: ["teamKey", "teamName"],
	computed: {
		leagueKey() {
			return this.$store.getters.activeLeagueKey
		},
	},
	methods: {
		navigateToTeamPage() {
			this.$router.push({ name: "league-team-home", params: { leagueKey: this.leagueKey, teamKey: this.teamKey } })
		},
	},
}
</script>
